/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  height: '478px',
  borderRadius: '32px',
  background: theme.palette.figma_surface?.main,
  padding: theme.spacing(6),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ContentBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  width: '290px',
}));

export const MessageBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const HeadingBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),

  '.MuiSvgIcon-root': {
    color: theme.palette.figma_emerald?.main,
  },
}));

export const HeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_emerald?.main,
  fontSize: '32px',
  fontWeight: 500,
}));

export const MessageText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
}));

export const OkButton = styled(Button)(({theme}) => ({
  width: '100%',
  height: '48px',
  color: theme.palette.semantic_dark?.primary.on,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  borderRadius: '8px',
  background: theme.palette.figma_primary?.dark,
  gap: theme.spacing(2),

  '&:hover': {
    background: theme.palette.figma_primary?.main,
  },
}));
